import { createLayoutApp } from "../layout/createLayoutApp";
import CmsNewsListItemNotFoundAppDestop from "../cmsNewsListItemNotFound/CmsNewsListItemNotFoundAppDestop.vue";
import { setDocumentControllerType } from "../util/controllerHelpers";

const mountEl = document.getElementById("cms-news-list-item-not-found");
if (mountEl && mountEl.getAttribute("data-vue3") === "true") {
  setDocumentControllerType("desktop");
  const app = createLayoutApp(CmsNewsListItemNotFoundAppDestop, {});
  app.config.globalProperties.$mobile = false;
  app.mount(mountEl);
}